import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { products } from '../data/mock';
import { ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

const Products = () => {
  const { language } = useLanguage();

  const sectionTitle = language === 'pt' ? 'As Nossas Marcas' : 'Our Brands';
  const sectionSubtitle = language === 'pt' ? 'Trabalhamos com as melhores marcas do mercado' : 'We work with the best brands in the market';
  const catalogText = language === 'pt' ? 'Ver Catálogo' : 'View Catalog';
  const comingSoon = language === 'pt' ? 'Em breve' : 'Coming soon';

  return (
    <section id="products" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-600 text-sm font-semibold rounded-full mb-4">
            {language === 'pt' ? 'Produtos' : 'Products'}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {sectionTitle}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-4">
            {sectionSubtitle}
          </p>
          <div className="w-20 h-1 bg-gradient-to-r from-emerald-500 to-teal-500 mx-auto rounded-full" />
        </div>

        {/* Brands Grid - 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((brand) => (
            <div
              key={brand.id}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100"
            >
              {/* Logo Image */}
              <div className="relative h-48 overflow-hidden bg-gray-100">
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="w-full h-full object-contain p-4 transition-transform duration-500 group-hover:scale-105"
                />
                {/* Overlay on hover */}
                <div 
                  className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-300"
                  style={{ backgroundColor: brand.color }}
                />
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 
                  className="text-2xl font-bold mb-3"
                  style={{ color: brand.color }}
                >
                  {brand.name}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed min-h-[48px]">
                  {brand.description}
                </p>

                {/* Button */}
                {brand.catalogLink === '#' ? (
                  <Button
                    disabled
                    className="w-full rounded-xl py-5 bg-gray-300 text-gray-500 cursor-not-allowed"
                  >
                    {comingSoon}
                  </Button>
                ) : (
                  <Button
                    asChild
                    className="w-full rounded-xl py-5 text-white transition-all duration-300 hover:shadow-lg hover:opacity-90"
                    style={{ backgroundColor: brand.color }}
                  >
                    <a
                      href={brand.catalogLink}
                      {...(brand.catalogLink.endsWith('/') && brand.catalogLink.startsWith('/')
                        ? {}
                        : { target: '_blank', rel: 'noopener noreferrer' })}
                      className="flex items-center justify-center gap-2"
                    >
                      {catalogText}
                      {!(brand.catalogLink.endsWith('/') && brand.catalogLink.startsWith('/')) && (
                        <ExternalLink className="w-4 h-4" />
                      )}
                    </a>
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Additional text */}
        <div className="text-center mt-12">
          <p className="text-lg text-gray-600 font-medium">
            {language === 'pt'
              ? 'Para outros produtos e marcas, dirija-se à nossa loja ou contacte-nos.'
              : 'For other products and brands, visit our store or contact us.'}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Products;
